var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 18.6745L7.79172 28.3104C6.69027 29.6035 4.72009 29.6821 3.51904 28.4811C2.31799 27.28 2.39667 25.3099 3.68968 24.2084L13.3256 16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 15.8729L21.2064 23.9998M16.1269 2.6665L8 10.7935M15.1112 3.68232L9.01593 9.77756C9.01593 9.77756 12.0635 13.841 15.1112 16.8886C18.1588 19.9362 22.2223 22.984 22.2223 22.984L28.3175 16.8886C28.3175 16.8886 25.2699 12.8252 22.2223 9.77756C19.1747 6.72994 15.1112 3.68232 15.1112 3.68232Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.d2268c0569c988b10487f61a35174d9f.svg";
export { ForwardRef as ReactComponent };